import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core'
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { Router } from '@angular/router';
declare let $: any;

@Component({
	selector: 'app-idle-modal',
	templateUrl: './idle-modal.component.html',
	styleUrls: ['./idle-modal.component.scss']
})
export class IdleModalComponent implements OnInit {

	idleState: string = 'Not Started';
	time: number = 0;

	constructor(private idle: Idle, private cd: ChangeDetectorRef, private authService:AuthenticationService, private router:Router) {
		idle.setIdle(20*60);
		idle.setTimeout(60);
		idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

		idle.onIdleEnd.subscribe(() => {
			this.idleState = 'Started';
			this.idle.watch();
			cd.detectChanges();
		});

		idle.onTimeout.subscribe(() => {
			this.idleState = "Timeout";
			this.authService.logout();
            window.location.reload();
		});

		idle.onIdleStart.subscribe(() => {
			this.idleState = "Idle";
		});

		idle.onTimeoutWarning.subscribe((countdown) => {
			this.time = countdown - 1;
			$("#timer").html(this.time);
			this.change(- this.time * 1000 + 60000);
		});
	}

	ngOnInit(): void {
		this.setStates();
		['mousemove', 'keydown', 'touchstart', 'click'].forEach(evt =>
			window.addEventListener(evt, this.resetIdleManually.bind(this))
		);
	}

	resetIdleManually() {
		if (this.idleState === 'Idle') {
			this.idle.watch();
			this.idleState = 'Started';
			this.cd.detectChanges();
		}
	}

	change(seconds: number) {

		// Angle to use, defined by 1 millisecond
		var intAngle = 0.1048335 * 0.001 * seconds;

		// Set up our canvas
		var canvas = document.getElementById("clock") as HTMLCanvasElement;

		if (canvas.getContext) // Does the browser support canvas?
		{
			var ctx = canvas.getContext("2d");

			// Clear canvas before re-drawing
			ctx.clearRect(0, 0, 300, 300);

			// Grey background ring
			ctx.beginPath();
			ctx.globalAlpha = 1;
			ctx.arc(150, 150, 140, 0, 6.283, false);
			ctx.arc(150, 150, 105, 6.283, ((Math.PI * 2)), true);
			ctx.fillStyle = "#bbb";
			ctx.fill();
			ctx.closePath();

			// Clock face ring
			ctx.beginPath();
			ctx.globalAlpha = 1;
			ctx.arc(150, 150, 140.1, -1.57, (-1.57 - intAngle), false);
			ctx.arc(150, 150, 105, (-1.57 - intAngle), ((Math.PI * 2) - 1.57), true);
			ctx.fillStyle = this.colourChanger(intAngle);
			ctx.fill();
			ctx.closePath();

			// Centre circle
			ctx.beginPath();
			ctx.arc(150, 150, 105, 0, 6.283, false);
			ctx.fillStyle = this.colourChanger(intAngle);
			ctx.fill();
			ctx.closePath();

			const fontSize = 150;
			ctx.font = `bold ${fontSize}px Nunito`;

			// Time number
			const number = this.time;
			const text = number.toString();
			const textMetrics = ctx.measureText(text);

			// Calc for the number position on canvas
			const x = (canvas.width - textMetrics.width) / 2;
			const y = 200;

			// Drawn the canvas
			ctx.fillStyle = "white";
			ctx.fillText(text, x, y);

		} else {
			// Put fallback for browsers that don't support canvas here...
		}
	}

	colourChanger(intAngle) {
		// RGB values
		// Green: 51 153 0
		// Yellow: 255 255 0
		// Red: 255 0 0
	  
		var intAngleNew = intAngle / (2 * Math.PI);
	  
		let r, g, b;
	  
		if (intAngleNew < 0.5) {
		  // Animate from green to yellow
		  r = Math.floor(51 + 408 * intAngleNew);
		  g = Math.floor(153 + 204 * intAngleNew);
		  b = 0;
		} else {
		  // Animate from yellow to red
		  r = 255;
		  g = Math.floor(255 - 255 * (intAngleNew - 0.5) * 2);
		  b = 0;
		}
	  
		return `rgb(${Math.floor(r)}, ${Math.floor(g)}, ${Math.floor(b)})`;
	  }

	setStates() {
		this.idle.watch();
		this.idleState = 'Started';
	}
}
